import { render } from "./App.vue?vue&type=template&id=feca6fae"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=feca6fae&lang=css"

import exportComponent from "D:\\a\\1\\s\\OMS\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__